import { Box,Button,Flex,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, Grid, GridItem } from "@chakra-ui/react";
import { TopDisplay } from "../../../../components";
import { IoMdAdd as AddIcon } from "react-icons/io";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState, useEffect } from "react";
import styled from "@emotion/styled";
import {TopLink} from '../';
import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
import { atom, useAtom } from 'jotai';
import { Formik,Form,Field } from "formik";
import apiCall from '../../../../utils/apiCall';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import * as Yup from 'yup';
import { Loader } from "../../../../customs";
import {TablePopUp} from '../../../../components';
import ReactPaginate from 'react-paginate';
import { TbReload as ReloadIcon } from "react-icons/tb";


const HeadStyle={
  borderBottom:"1px solid var(--cipm-light-green)",
  padding:'15px 5px',
  color:'var(--dark-green-color)',
}

const DataStyle = {
  padding:'5px 5px',
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type > *{
    display:none;
  }
  :hover > td{
    background-color:var(--table-highlight);
    &:last-of-type > *{
      display:block;
    }
  } 
  &.active > td:last-of-type > *{
    display:block !important;
  }  
`
const LevelSetUpAtom = atom<number | null>(null);

export default function LevelSetUp() {
  const [hide,set_hide] = useState<boolean>(true);
  const [active] = useAtom<number | string | null>(LevelSetUpAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);

  const {isLoading,data:allLevels} = useQuery(['exam-level'],{
    queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
    select(data){
      return data.data.Data;
    }
  })

  const [search,set_search] = useState('');
  const [filter_data,set_filter_data] = useState<any>(allLevels);

  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(allLevels)
    }
    else set_filter_data(allLevels)
  }
  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };
   useEffect(()=>{
    set_filter_data(allLevels)
  },[allLevels])

  const handleAddLevel = () =>{
      set_modal({
        header:'Exemption Level SetUp',
        content:<AddType />
      })
      set_open(true);
      // set_notification({
      //   type:'success',
      //   message: 'Added Successfully'
      // })
      // set_Nopen(true);
  }
     
   
  return (
    <>
    {isLoading?<Loader />:

    <Box>
      <TopLink />
      <TopDisplay label="Exemption Level SetUp" button_array={[

          // <Button onClick={handleAddLevel} bg="var(--dark-green-color)" color="var(--white-color)"  type="button" leftIcon={<AddIcon/>}>Add Exemption Level</Button>
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>  
        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Exam Level SetUp</Heading>
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
      
     {  filter_data && filter_data.length > 0 ? <TableContainer sx={{overflowY:'visible',h:'max-content'}}  mt="20px">
          <Table sx={{overflowY:'visible'}} size='sm'>
            <Thead>
              <Tr >
                {/* <Th sx={HeadStyle}>ID</Th> */}
                <Th sx={HeadStyle}>Level Name</Th>
                {/* <Th sx={HeadStyle}>Exam Amount</Th> */}
                {/* <Th sx={HeadStyle}>Route Name</Th> */}
                <Th sx={HeadStyle}>Exemption Amount</Th>
                <Th sx={HeadStyle}>IsActive</Th>



                <Th sx={HeadStyle} w="50px" ></Th>
              </Tr>
            </Thead>
            <Tbody sx={{overflowY:'visible'}}>
              {currentItems.map((eexemptionSetUp:any,index:number) =><ROWSTYLE className={eexemptionSetUp.Id === active?'active':''} key={eexemptionSetUp.Id}>
                {/* <Td sx={DataStyle}>{eexemptionSetUp.Id}</Td> */}
                <Td sx={DataStyle}>{eexemptionSetUp.Name}</Td>
                {/* <Td sx={DataStyle}>{eexemptionSetUp.ExamAmount}</Td> */}
                {/* <Td sx={DataStyle}>{eexemptionSetUp.RouteName ||'N/A'}</Td> */}
                <Td sx={DataStyle}>{eexemptionSetUp.ExemptionAmount}</Td>
                <Td sx={DataStyle}>{eexemptionSetUp.IsActive? 'YES':'NO'}</Td>
                <Td sx={DataStyle} w="50px" h="50px">
                  <TempPopUp index={eexemptionSetUp.Id} data={eexemptionSetUp}/>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No level SetUp SetUp'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
  }
    </>
    
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const AddSchema = Yup.object({
  Id:Yup.number(),
  ExemptionName:Yup.string().required(),
  ExemptionAmount:Yup.number().required(),

});

const AddType = (props:any) =>{
  // console.log({...props},'data')
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const {mutate:addUpdate,isLoading} = useMutation({
    mutationKey:['new-exemption-level'],
    mutationFn:async (data:any)=> {
      return await apiCall().post(`/ExamReport/member/CreateUpdateExemptionData`,data)},
    onSuccess:(data)=>{
     // console.log(data,'new data')
      set_notification({
        type:'success',
        message:data?.data?.Message || 'Exemption Level Added Successfully'
      })
      set_Nopen(true);
      queryClient.invalidateQueries({
        queryKey:['exam-level']
      })
    },
    onError(error:any){
      set_notification({
        type:'error',
        message:error?.data?.Message || ' ooops Error Occured'
      })
      set_Nopen(true);
    },
    onSettled:()=>{
      set_open(false);
    }
  } )
  return (
    <>
      <Formik
          initialValues={{
            ExemptionName:props.Name || '',

            ExemptionAmount:props.ExemptionAmount || '',
            ExamAmount:props.ExamAmount || '',


          }}
          validationSchema={AddSchema}
          onSubmit={(values:any) => {
           // console.log('clicked')
            const data:any = {
             
              ExemptionAmount:values.ExemptionAmount,
              ExamAmount:values.ExamAmount,


            };
            // console.log(data,'form data')
            if (props?.Id){data.Id = props.Id;
            data.ExemptionName=values.ExemptionName
          } 
          else  data.ExemptionName=values.ExemptionName


            addUpdate(data);
          }}
        >
         {(formik:any)=>{
        const {errors,values} = formik;

        // console.log(values,'values');
        // console.log(errors,'errors')
        return (
          <Form>
                <Flex flexDir={"column"} align={"center"} gap="20px">
                <Input
              as={Field}
              placeholder="ExemptionName"
              name="ExemptionName"
              type="text"
              color={props.Id ? 'gray.500' : 'black'}
               />
                <Input as={Field} 
                    placeholder="ExemptionAmount"
                    name="ExemptionAmount"
                    type="number"
                  />
                    <Input as={Field} 
                    placeholder="Exam Amount"
                    name="ExamAmount"
                    hidden={true}
                    type="number"
                  />
                  <Box color="red" fontSize=".7rem">
                    {errors && Object.values(errors).map((error:any,index:number) => <Box key={index}>{error}</Box>)}
                  </Box>
                  <Button disabled={isLoading} type="submit" bg="var(--dark-green-color)" color="var(--white-color)" >
                    {isLoading?"Loading":'Submit'}
                  </Button>
                </Flex>
                  
              </Form>
          )}}
        </Formik>
    </>
  )
}

const TempPopUp = (props:any) =>{
  const index = props.index;
  const data = props.data;
  const [active,set_active] = useAtom(LevelSetUpAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const queryClient = useQueryClient();
  // const {mutate:deleteFee,isLoading} = useMutation({
  //   mutationKey:['delete-destination-amount'],
  //   mutationFn:async () => await apiCall().get(`/exam/setup/destinationAmount/${data?.Id}/delete`),
  //   onSuccess(data:any) {
  //     queryClient.invalidateQueries({queryKey:["destination-amount"]})
  //     set_notification({
  //       type:'success',
  //       message:data?.data?.Message || 'Deleted Successfully'
  //     })
  //     set_Nopen(true);
  //   },
  //   onSettled(){
  //     set_open(false);
  //   }
  // })

  const handleClick = () =>{
    if(index === active){
      set_active(null);
      return;
    }
    else{
      set_active(index);
    }
  }
  const handleView= () =>{
    set_modal({
      header:'View Exemption Level SetUp',
      content:<Grid>
        {/* <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span> Id</span>
          <span>{data?.Id}</span>
        </GridItem > */}
        <GridItem as={Flex} justify="space-between" p="10px 0">
        <Text><b>Exemption Name:</b></Text>
        <Text>{data?.Name}</Text>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
        <Text><b>Exemption AMount:</b></Text>
        <Text>{data?.ExemptionAmount}</Text>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
        <Text><b>Exemption Level:</b></Text>
        <Text>{data?.Name}</Text>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
        <Text><b>Active:</b></Text>
        <Text>{data?.IsActive? 'YES':'NO'}</Text>
        </GridItem>
       
      </Grid>
    })
    set_open(true);
    handleClick();
  }
  const handleEdit = () =>{
    handleClick();
    set_modal({
      header:'Edit Exemption Level SetUp',
      content:<AddType {...data}/>
    });
    set_open(true);
    handleClick();
    
  }
  // const handleDelete = () =>{
  //   set_modal({
  //     header:'Delete Destination Amount SetUp',
  //     content:<Grid gap="20px">
  //       <GridItem>Are you Sure you want to delete this destination amount Setup</GridItem>
  //       <GridItem as={Flex} justify="space-between" p="20px 0">
  //         <Button disabled={isLoading} onClick={()=>deleteFee()} bg="var(--dark-green-color)"
  //           color="var(--white-color)" >{isLoading?'Loading':'Delete'}</Button>
  //         <Button disabled={isLoading} 
  //           variant="outline" bg="var(--white-color)"
  //           onClick={()=>set_open(false)}
  //           border="1px solid var(--dark-green-color)"
  //           color="var(--dark-green-color)" >Cancel</Button>
  //       </GridItem>
  //     </Grid>
  //   });
  //   set_open(true);
  // }
  
  return (
    <TablePopUp click={handleClick} options={[
      {label:'View Levels',click:handleView},
      {label:'Edit Level',click:handleEdit},
      // {label:'Delete Amount',click:handleDelete}
    ]} />
  )
}


